import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../../assets/images/logo.svg";
import Iconplus18 from "../../assets/images/footer-18plus.png";
import IconGcb from "../../assets/images/logo-gcb.svg";
import { ReactComponent as IconFacebook } from "../../assets/icons/social/icon-facebook.svg";
import { ReactComponent as IconTelegram } from "../../assets/icons/social/icon-telegram.svg";
import { ReactComponent as IconWhatsapp } from "../../assets/icons/social/icon-whatsapp.svg";
import { ReactComponent as IconInstagram } from "../../assets/icons/social/icon-instagram.svg";
import { ReactComponent as IconTiktok } from "../../assets/icons/social/icon-tiktok.svg";
import { ReactComponent as IconYoutube } from "../../assets/icons/social/icon-youtube.svg";
import { ReactComponent as IconTwitter } from "../../assets/icons/social/icon-twitter.svg";
import { ReactComponent as IconKick } from "../../assets/icons/social/icon-kick.svg";
import { ReactComponent as IconDiscord } from "../../assets/icons/social/icon-discord.svg";
import PartnerLogo from "../../assets/images/provider-logos.png";

const Footer = () => {
  const { t } = useTranslation();
  const socialIcon = [
    {
      icon: <IconFacebook />,
      path: "https://www.facebook.com/betxlabo",
    },
    //{ icon: <IconWhatsapp />, path: "https://wa.me/" },
     { icon: <IconTelegram />, path: "http://t.me/betlabo" },
    // { icon: <IconInstagram />, path: "#" },
    // { icon: <IconTiktok />, path: "#" },
    // { icon: <IconYoutube />, path: "#" },
    // { icon: <IconTwitter />, path: "#" },
    // { icon: <IconKick />, path: "#" },
    // { icon: <IconDiscord />, path: "#" },
  ];

  const footerNav = [
    { link: "#", label: t("About Us") },
    { link: "#", label: t("Promotions") },
    { link: "#", label: t("Terms & Conditions") },
    { link: "#", label: t("Terms of Use") },
    { link: "#", label: t("Privacy Policy") },
    { link: "#", label: t("Responsible Gaming") },
    { link: "#", label: t("Self Exclusion") },
    { link: "#", label: t("Dispute Resolution") },
    { link: "#", label: t("AML Policy") },
    { link: "#", label: t("Fairness & RNG Testing Methods") },
    { link: "#", label: t("KYC Policy") },
    { link: "#", label: t("Privacy & Management of Personal Data") },
    { link: "#", label: t("Accounts, Payouts & Bonuses") },
    { link: "#", label: t("Customer Service") },
    { link: "#", label: t("Affliliates") },
    { link: "#", label: t("Become an Affliliate") },
  ];

  return (
    <footer className="bg-[#2b2e3b]" id="appFooter">
      <div className="w-full mx-auto md:p-2 p-3 md:pb-8 md:pt-6">
        <Link to={"/sportsbook/sports"} className="flex justify-center items-center space-x-3 ">
          <span className="flex w-[120px]">
            <img src={Logo} alt="logo" title="Logo" />
          </span>
        </Link>
        <nav className="max-w-[1400px] px-3 mx-auto flex flex-wrap md:flex-nowrap justify-center gap-3 items-center space-x-3 border-y border-white my-6 py-6">
          {footerNav.map((item) => (
            <NavLink key={item.id} to={item.link} className={`max text-center font-medium lg:text-[14px] text-white hover:text-primary/70 `}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="max-w-[1200px] mx-auto md:text-sm text-[0.625rem]">
          <img src={PartnerLogo} className="my-3" />
          <p className="my-4">
            <a href="#" className="text-[#5571aa]">
              {t("www.gastonbet365.com")}
            </a>{" "}
            {t(
              "is operated by Crimson Peak Holdings Ltd., registered under No. 764529 at Santa Rosaweg, Orion Plaza, Willemstad, Curaçao. It is fully licensed and regulated by Curaçao eGaming under license number 5829143/KL."
            )}
          </p>
          <p>
            {t("In order to register for this website, the user is required to accept the")}{" "}
            <a href="#" className="text-[#5571aa]">
              {t("General Terms and Conditions")}
            </a>
            {t(
              ".In the event the General Terms and Conditions are updated, existing users may choose to discontinue using the products and services before the said update shall become effective, which is a minimum of two weeks after it has been announced."
            )}
          </p>
        </div>
      </div>
      <div className="bg-[#3b3d50] flex justify-center items-center space-x-6 py-6">
        <div className="max-w-[1200px]">
          <div className=" flex justify-center items-center space-x-6 mt-8">
            {/* Plus18 Icon with Text */}
            <div className="flex items-center justify-center lg:gap-3 lg:space-x-4 gap-2 sm:gap-0">
              {/*<img src={IconGcb} alt="gcb" className="h-[75px]" />*/}
              <img src={Iconplus18} alt="plus18" className="h-[75px]" />
            </div>

            {/* Vertical Separator */}
            <div className="border-l-2  border-white h-[3.2rem] sm:h-[3.5rem]"></div>

            {/* Social Media Links */}
            <div className="flex lg:space-x-2 flex-wrap sm:justify-normal justify-center gap-2 sm:gap-0">
              {socialIcon.map((item, index) => (
                <NavLink
                  // key={item.id}
                  to={item.path}
                  target="_blank"
                  className={`text-nowrap [&_svg_path]:fill-white [&_svg_path]:hover:fill-primary`}
                >
                  {item.icon}
                </NavLink>
              ))}
            </div>
          </div>

          <p className="text-[0.82rem] text-center mt-4 font-bold text-[#c5c5cb]">{t("CopyrightText")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
